import React from 'react';
import { HolderOutlined } from '@ant-design/icons';

const DragHandle = ({ dragHandleProps, label }) => (
	<span {...dragHandleProps} className="ChecklistEditor-handle" aria-label={label}>
		<HolderOutlined />
	</span>
);

export default DragHandle;
